import styled from 'styled-components';
import { paddings } from '~/styled/variables';

export const ErrorBoundaryContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  height: 100%;
  width: 100%;
  align-content: center;
  align-items: center;
  white-space: nowrap;
`;

export const ErrorBoundaryWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  button {
    margin-top: ${paddings.smallPadding};
  }
`;
